import gql from 'graphql-tag';

export default gql`
  query checkIsBadWord($word: String!) {
    checkIsBadWord(word: $word) {
      isValid
    }
  }
`;
